import { Navigate, Outlet } from 'react-router-dom';
import { useRole } from '../utils/RoleContext';
import { canAccessRoute } from '../permissions';
import Loader from '../components/Loader';

const PermissionRoute = ({ routePermission, redirectTo = '/restricted' }) => {
    const { role } = useRole();

    if (!role) {
        return <Loader />;
    }

    const hasAccess = canAccessRoute(role, routePermission);

    if (!hasAccess) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};

export default PermissionRoute;
